/* eslint-disable no-new */

import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import MenuItem from '~components/MenuItem'
import AccountMenu from '~components/AccountMenu'
import AccountMenuItem from '~components/AccountMenuItem'
import QuickLink from '~components/QuickLink'
import SearchForm from '~components/ui/SearchForm'
import SearchOverlay from '~components/SearchOverlay'
import Sticky from '~helpers/Sticky'
import RoundedIcon from '~components/ui/RoundedIcon'
import MediaQuery from '~components/helpers/MediaQuery'
import { loadBrands } from '~redux/shop'
import { isScreenSize } from '~helpers/mediaQuery'

class Nav extends React.Component {
  constructor () {
    super()

    this.state = {
      open: false,
      overlay: false,
      transform: false
    }

    this.items = [{
      title: 'Shop',
      link: '/shop',
      icon: 'label',
      children: [],
      exact: false
    }]

    this.headerRef = React.createRef()
    this.orientationHander = this.onOrientationChange.bind(this)
  }

  componentDidMount () {
    new Sticky(this.headerRef.current, {
      cssClasses: ['-translate-y-3/2']
    })

    this.props.loadBrands()
    document.addEventListener('keyup', this.handleDocumentKeyup.bind(this))
    window.addEventListener('orientationchange', this.orientationHander)
  }

  componentWillUnmount () {
    document.removeEventListener('keyup', this.handleDocumentKeyup.bind(this))
    window.removeEventListener('orientationchange', this.orientationHander)
  }

  handleDocumentKeyup (e) {
    const searchIsAvailable = ['input', 'textarea'].indexOf(e.target.nodeName.toLowerCase()) === -1

    if (e.code === 'Slash' && searchIsAvailable) {
      this.setState((state) => {
        return { overlay: true }
      })
    }

    if (e.code === 'Escape') {
      this.setState((state) => {
        return { overlay: false }
      })
    }
  }

  toggleNav (e) {
    const open = this.state.open

    this.setState({
      open: !open
    })

    // Temporary until permanent solution found
    document.body.classList.toggle('overflow-y-hidden')
  }

  hideNav () {
    this.setState({
      open: false
    })

    // Temporary until permanent solution found
    document.body.classList.remove('overflow-y-hidden')
  }

  toggleOverlay () {
    const overlay = this.state.overlay

    this.setState((state) => {
      return { overlay: !overlay }
    })
  }

  shouldRemoveTransform () {
    return this.state.open && !isScreenSize('lg')
  }

  onOrientationChange () {
    this.hideNav()
  }

  render () {
    const shopItem = this.items.find(i => i.link === '/shop')

    if (shopItem) {
      shopItem.children = this.props.brands.map(brand => ({
        title: brand.name,
        link: brand.url
      }))
    }

    return (
      <>
        <div
          ref={this.headerRef}
          className={classNames(
            'top-0 z-30 fixed w-full h-18 xl:h-21.5',
            { 'transform transition-transform duration-300 ease-in-out': !this.shouldRemoveTransform() }
          )}
        >
          {!this.props.isSuspended && (
            <SearchOverlay showOverlay={this.state.overlay} toggleOverlay={this.toggleOverlay.bind(this)} />
          )}

          <span className={classNames('w-full block h-full absolute bg-lightGrey z-40 left-0 right-0 top-0 border-coral border-b lg:bg-white lg:border-pink')} aria-hidden="true"></span>

          <div className="flex items-center h-full px-4 mx-auto xxl:container md:px-8 xxl:px-0">
            <button type="button" className="z-40 flex items-center h-full px-4 mr-4 -ml-4 border-r border-coral lg:hidden" aria-label="Main menu" aria-expanded="false" onClick={this.toggleNav.bind(this)}>
              <span aria-hidden="true" className="block w-4 h-4">
                <Sprite name={this.state.open ? 'cross' : 'menu'} />
              </span>
            </button>

            <a href="/" className="hover:opacity-75 focus:opacity-75 transition-opacity duration-150 z-40 block w-16.5 h-10 md:mr-6 lg:mr-0 xl:w-22.5 xl:h-13.5">
              <Sprite name="logo" />
            </a>

            {this.items.length > 0 && (
              <nav className={classNames('fixed flex-col overflow-scrolling overflow-x-hidden bg-white w-full h-full left-0 right-0 top-0 pt-29 pb-10 lg:overflow-visible lg:overflow-x-visible lg:flex lg:static lg:flex-row lg:p-0 lg:w-auto lg:h-full lg:z-40 lg:bg-transparent lg:ml-10 xxl:ml-20', { hidden: !this.state.open }, { 'overflow-y-scroll': this.state.open })}>
                <div className="px-4 mx-auto md:px-8 lg:m-0 lg:px-0">
                  <ul className="w-full -my-5 lg:flex lg:my-0 lg:h-full">
                    {!this.props.isSuspended && this.items.map((item, index) => (
                      <li className="my-10 lg:m-0" key={index}>
                        <MenuItem
                          icon={item.icon}
                          title={item.title}
                          link={item.link}
                          items={item.children}
                          exact={item.exact}
                          toggleNav={this.toggleNav.bind(this)}
                        />
                      </li>
                    ))}

                    <li className="my-10 lg:m-0">
                      <MenuItem
                        icon="dashboard"
                        title="Dashboard"
                        link="/"
                        exact={true}
                        toggleNav={this.toggleNav.bind(this)}
                      />
                    </li>

                    <MediaQuery type="max" breakpoint="lg">
                      <li className="my-10 group lg:m-0">
                        <AccountMenuItem
                          link="/account"
                          toggleNav={this.toggleNav.bind(this)}
                        />
                      </li>

                      {!this.props.isSuspended && (
                        <li className="my-10 group lg:m-0">
                          <MenuItem
                            exact={true}
                            title="Basket"
                            link="/basket"
                            icon="basket"
                            basket={this.props.hasCartItems}
                            toggleNav={this.toggleNav.bind(this)}
                          />
                        </li>
                      )}
                    </MediaQuery>
                  </ul>
                </div>
              </nav>
            )}

            {!this.props.isSuspended && (
              <MediaQuery breakpoint="md">
                <SearchForm className="md:mr-6 xl:mr-10" />
              </MediaQuery>
            )}

            <div className={classNames('relative inline-flex items-center ml-auto z-40 lg:inline-flex', { hidden: this.state.open })}>
              {!this.props.isSuspended && (
                <QuickLink
                  link="/basket"
                  title="Basket"
                  icon="basket"
                  className="mr-4 lg:mr-6 xl:mr-10"
                  basket={this.props.hasCartItems}
                  exact={true}
                />
              )}

              {!this.props.isSuspended && (
                <MediaQuery type="max" breakpoint="md">
                  <button type="button" onClick={this.toggleOverlay.bind(this)} className="flex items-center group" aria-label="Search">
                    <RoundedIcon name="search" className="block w-10 h-10 lg:w-7 lg:h-7" />
                  </button>
                </MediaQuery>
              )}

              <MediaQuery breakpoint="md">
                <AccountMenu />
              </MediaQuery>
            </div>
          </div>
        </div>
      </>
    )
  }
}

Nav.propTypes = {
  brands: PropTypes.array,
  hasCartItems: PropTypes.bool,
  loadBrands: PropTypes.func,
  isSuspended: PropTypes.bool
}

const mapStateToProps = (state, ownProps) => ({
  ...ownProps,
  brands: state.shop.brands,
  hasCartItems: state.shop.cart && state.shop.cart.line_items.physical_items.length > 0,
  isSuspended: state.auth.isSuspended
})

const mapDispatchToProps = dispatch => ({
  loadBrands: () => { dispatch(loadBrands()) }
})

export default connect(mapStateToProps, mapDispatchToProps)(Nav)
